import { Colors } from "../customComponents/materialUI/index";

module.exports = {
    ZDEPTH: 0,
    DASHBOARDBACKGROUND: "#ebeff2",
    myWalletSaveLabel: "#606060",
    myWalletSaveBackground: "#f8f8f8",
    saveBackground: "#5e89c6",
    secondarySaveBackground: "#5e89c6",
    cancelBackground: "#ffffff",
    saveLabel: "#ffffff",
    cancelLabel: "#4a4a4a",
    mainGridStyle: {
        // padding: '5px 0px 0px 0px'
        padding: 0
    },
    // searchableSelectInput: {
    //     width: "90%",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     textAlign: "left",
    //     WebkitTextFillColor: "#0b1322",
    //     color: "#0b1322",
    //     opacity: 0.5,
    //     border: "none",
    //     padding: "6px 8px 3px 10px"
    // },

    // Not useed Anywhere
    // searchableSelectIcon: {
    //     width: "40px",
    //     marginLeft: "0px",
    //     marginRight: "0px",
    //     height: 14,
    //     top: "3px",
    //     right: "-5px"
    // },

    exampleImageInput: {
        cursor: "pointer",
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        opacity: 0,
        width: "100%",
        zIndex: "10"
    },
    // fileSelector: {
    //     cursor: "pointer !important",
    //     position: "absolute",
    //     top: 0,
    //     opacity: 0,
    //     zIndex: 10,
    //     width: "40%",
    //     height: "100%",
    //     left: "10%"
    // },
    // Not used Anywhere
    // myWalletTitle: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 14,
    //     fontWeight: "bolder",
    //     textAlign: "left",
    //     color: "#4a4a4a",
    //     borderBottom: "1px solid #eef2f7",
    //     paddingBottom: 12
    // },
    // myWalletName: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     textAlign: "center",
    //     color: "#3c424e"
    // },
    // OrgBalanceHeading: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 18,
    //     textAlign: "center",
    //     color: "#3c424e"
    // },
    // currentBal: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 10,
    //     fontWeight: "normal",
    //     textAlign: "center",
    //     color: "#596d90",
    //     marginBottom: 3,
    //     textTransform: "uppercase"
    // },
    // orgNameStyle: {
    //     width: "290px",
    //     marginRight: "20px",
    //     height: "217px"
    // },
    // transferButton: {
    //     justifyContent: "center",
    //     margin: "7px 25px"
    // },
    // currentINR: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     fontWeight: "bold",
    //     textAlign: "center",
    //     color: "#3c424e",
    //     marginBottom: 10
    // },

    // walletcurrentINR: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     fontWeight: "normal",
    //     textAlign: "right",
    //     color: "#0b1322"
    // },
    // walletcurrentINRDisbaled: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     fontWeight: "normal",
    //     textAlign: "right",
    //     color: "#868484"
    // },
    // myWalletStatus: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 10,
    //     fontWeight: "normal",
    //     textAlign: "center",
    //     margin: 8,
    //     color: "#617495",
    //     float: "left"
    // },

    // Not used Anywhere

    // transferFundStyle: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 16,
    //     fontWeight: "normal",
    //     textAlign: "center",
    //     margin: 8,
    //     color: "#617495",
    //     float: "center",
    //     borderRadius: "2px",
    //     border: "solid 1px #e8edf4"
    // },

    // transferFundUi: {
    //     fontWeight: "normal",
    //     margin: 8,
    //     borderRadius: "2px",
    //     cursor: "pointer",
    //     color: "rgb(84, 105, 141)",
    //     lineHeight: "normal",
    //     fontFamily: "Roboto-Regular",
    //     backgroundColor: "rgb(255, 255, 255)",
    //     border: "1px solid rgb(232, 237, 244)",
    //     fontSize: "12px",
    //     textAlign: "left",
    //     opacity: "1",
    //     padding: "6px"
    // },
    // Not used Anywhere

    // transferNowStyle: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 20,
    //     fontWeight: "normal",
    //     textAlign: "right",
    //     margin: 20,
    //     color: "#617495",
    //     borderRadius: "2px",
    //     border: "solid 1px #e8edf4"
    // },

    // transferFundHeading: {
    //     fontSize: 17,
    //     margin: "23px 0px 0px 0px"
    // },
    // bulkCheckboxStyle: {
    //     borderRadius: "3px",
    //     backgroundColor: "#ffffff",
    //     border: "solid 1px #e8edf4",
    //     width: "45%",
    //     padding: "4px"
    // },
    loginPage: {
        mainContainer: {
            width: 933,
            height: 413,
            borderRadius: 10,
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: "auto"
        },
        middleContainer: {
            margin: "0 auto",
            width: 390,
            textAlign: "center",
            position: "relative"
            // top: 60
        },
        inputFieldContainer: {
            backgroundColor: "#ffffff",
            padding: 50,
            borderRadius: 6,
            boxShadow: "0 6px 20px 0 rgba(2, 11, 25, 0.13)",
            border: "solid 1px #eef2f7"
        },
        leftContainer: {
            position: "absolute",
            top: -60,
            left: 10,
            backgroundColor: "#f5f5f5",
            boxShadow: " 0 0 11px 2px rgba(0, 0, 0, 0.5)",
            borderRadius: 10,
            height: 534,
            width: 403
        },
        logoDivStyle: {
            margin: "auto",
            marginTop: 30,
            width: 170,
            textAlign: "center"
        },
        happayLogo: {
            paddingBottom: 10,
            borderBottom: "1px solid rgba(74,74,74,0.23)",
            cursor: "pointer"
        },
        textBelowLogo: {
            fontSize: 22,
            fontWeight: 300,
            color: "#4a4a4a"
        },
        rightContainer: {
            position: "absolute",
            right: 70,
            top: 40,
            textAlign: "center",
            color: "#ffffff",
            width: 360,
            fontSize: 18
        },
        regRightContainer: {
            position: "absolute",
            right: 70,
            top: 0,
            textAlign: "left",
            color: "#ffffff",
            width: 360
        },
        floatingTextStyle: {
            fontSize: 16,
            fontWeight: 300,
            color: "#4a4a4a",
            opacity: "0.7"
        },
        floatingRegTextStyle: {
            fontSize: 14,
            // fontFamily: "Roboto-Regular",
            fontWeight: 400,
            color: "#4a4a4a"
        },
        savebuttonStyle: {
            margin: "5px",
            textAlign: "center",
            height: "25px",
            lineHeight: "25px",
            overflow: "hidden",
            borderRadius: "100px",
            display: "inline-block",
            cursor: "pointer",
            transition: "none !important",
            transform: "none !important"
        },
        verificationLink: {
            width: "367px",
            height: "66px",
            paddingLeft: "64px",
            textAlign: "initial",
            // fontSize: '16px',
            fontWeight: 300,
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: 1.38,
            letterSpacing: "normal",
            color: "#4a4a4a"
        },
        verifyMailNote: {
            margin: "158px 10px 2px 10px",
            // width: '343px',
            height: "28px",
            // fontFamily: "Roboto-Regular",
            fontWeight: 400,
            fontSize: "11px",
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: 1.4,
            letterSpacing: "normal",
            textAlign: "center",
            color: "#7e7e7e"
        }
    },
    // Will see it later
    SearchFieldFontStyling: {
        width: "100%",
        fontSize: "14px",
        padding: "0px",
        fontWeight: "normal"
    },
    // Not used anywhere
    // ExtraFieldFontStyling: {
    //     width: "92%",
    //     fontSize: "12px",
    //     height: "auto",
    //     padding: "8px 10px",
    //     fontWeight: "normal"
    // },
    // EfFontStyling: {
    //     width: "100%",
    //     fontSize: "14px",
    //     padding: "0px",
    //     fontWeight: "normal"
    // },
    // sideNavListtyle: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     cursor: "pointer",
    //     fontWeight: "normal",
    //     color: "#0b1322",
    //     borderBottom: "1px solid #eef2f7"
    // },
    selectableListStyle: {
        selectableStyle: {
            fontWeight: 400,
            border: 10,
            boxSizing: "border-box",
            display: "block",
            cursor: "pointer",
            textDecoration: "none",
            margin: 0,
            padding: 0,
            outline: "none",
            fontSize: 14,
            transform: "translate(0px, 0px)",
            verticalAlign: "middle",
            color: "#ffffff",
            position: "relative",
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
            backgroundColor: "#5ccf78",
        },
        selectableStyleNew: {
            fontWeight: 600,
            border: 10,
            boxSizing: "border-box",
            display: "block",
            cursor: "pointer",
            textDecoration: "none",
            margin: 0,
            padding: "0px 0px 0px 6px",
            outline: "none",
            fontSize: 14,
            transform: "translate(0px, 0px)",
            verticalAlign: "middle",
            color: "#1D7CBF",
            position: "relative",
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
            backgroundColor: "rgba(29, 124, 191, 0.1)",
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px",
        },
        ListStyle: {
            lineHeight: "34px",
            padding: "0px",
            fontSize: 14
        },
        ListInnerStyle: {
            marginLeft: "10px",
            padding: "0px",
            fontSize: 14
        },
        // fontFamily: "Roboto-Medium,sans-serif",
        fontWeight: 400,
        border: 10,
        boxSizing: "border-box",
        display: "block",
        cursor: "pointer",
        textDecoration: "none",
        margin: 0,
        padding: 0,
        outline: "none",
        fontSize: 14,
        transform: "translate(0px, 0px)",
        verticalAlign: "middle",
        color: "rgba(0, 0, 0, 0.870588)",
        position: "relative",
        transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
        backgroundColor: "#F2F2F2"
    },
    // cell10Style: {
    //     // paddingLeft:8,
    //     // paddingRight:8,
    //     background: "#ebeff2",
    //     // boxShadow:'0 0 2px 0 rgba(0, 0, 0, 0.14)'
    //     padding: "0px 0px 0px 8px"
    // },

    // cell2Style: {
    //     background: "#ebeff2",
    //     boxShadow: "0 1px 3px 0 #0000001e",
    //     zIndex: 1000
    //     // height:'calc(100vh - 50px)',
    // },
    //  Not used Anywhere
    // arrowForwardStyle: {
    //     color: "#237BFB"
    // },
    // paginationComponentCss: {
    //     width: "100%",
    //     display: "flex",
    //     paddingLeft: 16,
    //     paddingRight: 2,
    //     backgroundColor: "#ffffff",
    //     height: 46,
    //     fontSize: 10,
    //     lineHeight: 5,
    //     // borderTop:'solid 1px #eef2f7',
    //     color: "#0b1322"
    // },
    // paginationTextBlockStyle: {
    //     float: "right",
    //     margin: 0
    // },
    paginationComponentSmallActionButton: {
        height: 28,
        width: 28,
        lineHeight: 0,
        padding: "4px 6px",
        border: "solid 1px #e8edf4",
        borderRadius: 3,
        marginRight: 8,
        cursor: "pointer"
    },
    // paginationComponentSmallActionButtonWithTopHide: {
    //     height: 28,
    //     width: 28,
    //     lineHeight: 0,
    //     padding: "4px 6px",
    //     border: "solid 1px #e8edf4",
    //     borderRadius: 3,
    //     marginRight: 8,
    //     cursor: "pointer"
    // },
    // Used in Commented code
    // saveSearchStyle: {
    //     fontWeight: "normal",
    //     width: "92%",
    //     fontSize: "13px",
    //     color: "#606060",
    //     padding: "0px",
    //     fontWeight: "normal"
    // },
    // mainLoader: {
    //     display: "inline-block",
    //     margin: 0,
    //     paddingTop: "15%",
    //     position: "absolute",
    //     top: 0,
    //     width: "100%",
    //     height: "100%",
    //     zIndex: 3000,
    //     backgroundColor: "rgba(35, 52, 76, 0.50)",
    //     opacity: 0.5,
    //     textAlign: "center"
    // },
    // Not used ANY where
    // analyticsLoader: {
    //     display: "inline-block",
    //     margin: 0,
    //     paddingTop: "20%",
    //     position: "absolute",
    //     top: 0,
    //     width: "100%",
    //     height: 900,
    //     zIndex: 3000,
    //     backgroundColor: "#000000",
    //     opacity: 0.5,
    //     textAlign: "center"
    // },

    // Not used ANY where
    // smallLogoPaperStyle: {
    //     height: 30,
    //     width: 30,
    //     margin: 20,
    //     boxShadow: "none",
    //     textAlign: "center",
    //     display: "inline-block",
    //     border: "2px solid #707070"
    // },
    // HeaderButtonStyle: {
    // 	height : '50px',
    // 	lineHeight:'50px',
    // 	borderRadius: '100px',
    // },
    // Will se it later
    saveBtn: {
        margin: "5px",
        textAlign: "center",
        height: "33px",
        lineHeight: "24px",
        overflow: "hidden",
        display: "inline-block",
        borderRadius: "3px",
        transition: "none !important",
        transform: "none !important"
    },

    // Not used ANY where
    // searchMyWalletBtn: {
    //     margin: "5px",
    //     textAlign: "center",
    //     height: "25px",
    //     position: "relative",
    //     bottom: -33,
    //     right: -8,
    //     lineHeight: "23px",
    //     overflow: "hidden",
    //     color: "#ffffff",
    //     border: "2px solid #ffffff",
    //     backgroundColor: "#237bfb",
    //     borderRadius: "100px",
    //     display: "inline-block",
    //     transition: "none !important",
    //     transform: "none !important",
    //     cursor: "pointer"
    // },
    // Not used ANY where
    // saveBtnStyle: {
    //     height: "20px",
    //     lineHeight: "20px",
    //     borderRadius: "0px",
    //     transition: "none !important",
    //     transform: "none !important"
    // },
    // Not used ANY where
    // secondarySaveBtn: {
    //     margin: 8,
    //     textAlign: "center",
    //     height: 30,
    //     lineHeight: "28px",
    //     overflow: "hidden",
    //     color: "#ffffff",
    //     backgroundColor: "#5e89c6",
    //     borderRadius: "3px",
    //     display: "inline-block"
    // },
    // Not used ANY where

    // myWalletLabel: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     fontWeight: "normal",
    //     textAlign: "center",
    //     color: "#606060"
    // },

    // myWalletOpening: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     /*position: 'relative',
    // 	right: '-9px',
    // 	top:'34px', */
    //     paddingTop: 30,
    //     fontWeight: "normal",
    //     color: "white"
    // },

    // Not used ANY where

    // myWalletSaveBtn: {
    //     borderRadius: 100,
    //     backgroundColor: "#f8f8f8",
    //     boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.29)",
    //     border: "1px solid rgba(96,96,96,0.6)",
    //     margin: "5px",
    //     textAlign: "center",
    //     height: "25px",
    //     lineHeight: "25px",
    //     overflow: "hidden",
    //     color: "#237bfb",
    //     display: "inline-block",
    //     cursor: "pointer",
    //     transition: "none !important",
    //     transform: "none !important"
    // },

    // Not used ANY where

    // myWalletRequestBtn: {
    //     textAlign: "center",
    //     marginBottom: -15
    // },

    // Not used ANY where

    // myWalletDivider: {
    //     border: "solid 1px #dadada",
    //     marginLeft: 16,
    //     width: 150,
    //     marginTop: "-8px"
    // },

    // Not used ANY where

    // saveBtnRippleStyle: {
    //     transition: "none !important",
    //     transform: "none !important"
    // },

    // Not used ANY where

    // secondarySaveBtnStyle: {
    //     height: "20px",
    //     lineHeight: "20px",
    //     borderRadius: "0px"
    // },
    // Not used ANY where

    // myWalletSaveBtnStyle: {
    //     height: "20px",
    //     lineHeight: "20px"
    // },

    // cancelBtn: {
    //     margin: "5px",
    //     height: "33px",
    //     lineHeight: "24px",
    //     overflow: "hidden",
    //     color: "#0b1322",
    //     fontFamily: "Roboto-Medium",
    //     borderRadius: "3px",
    //     border: "solid 1px #e8edf4"
    // },
    cardAction: {
        textAlign: "right"
    },
    CardStyle: {
        width: "100%",
        height: "auto",
        marginLeft: "0px"
    },
    // Not used anywhere
    // empWalletPassbookTable: {
    //     backgroundColor: "#ffffff",
    //     position: "absolute",
    //     color: "#606060",
    //     top: 155,
    //     padding: "12px 8px",
    //     left: 30,
    //     right: 30
    // },
    // Not used anywhere
    // empWalletPassStyle: {
    //     backgroundColor: "#237bfb",
    //     height: 180,
    //     color: "#ffffff",
    //     padding: 0,
    //     position: "relative",
    //     margin: "0 auto",
    //     marginTop: 12
    // },
    // Not used anywhere
    // empSettlementStyle: {
    //     backgroundColor: "#237bfb",
    //     height: 180,
    //     color: "#ffffff",
    //     padding: 0,
    //     position: "relative",
    //     margin: "0 auto"
    // },
    // Not used anywhere
    // myWalletCardStyle: {
    //     width: "100%",
    //     height: "100%",
    //     marginLeft: "0px"
    // },
    // Not used anywhere
    // orgWalletCardStyle: {
    //     paddingLeft: "50px",
    //     backgroundColor: "#f5f5f5"
    // },
    cardHeader: {
        fontSize: "14px",
        color: "#4a4a4a",
        paddingLeft: "50px"
    },
    // toggle: {
    //     paddingRight: 450
    // },
    labelToggle: {
        // fontFamily: "Roboto-Regular",
        fontWeight: 400,
        marginLeft: "10px",
        fontSize: "12px",
        color: "#4a4a4a"
    },
    // labelWalletSummary: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     marginLeft: "3px",
    //     color: "#4a4a4a"
    // },
    // labelWalletLoad: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     color: "#4a4a4a",
    //     display: "flex"
    // },

    // Not used anywhere
    // myPassbookLabel: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 14,
    //     fontWeight: "bold",
    //     color: "#ffffff"
    // },

    selectFieldWalletLoad: {
        width: 200,
        fontSize: 12,
        // fontFamily: "Roboto-Regular"
        fontWeight: 400
    },
    // Not used anywhere
    // selectFieldMyWalletPass: {
    //     width: 150,
    //     fontSize: 12,
    //     fontFamily: "Roboto-Regular"
    // },
    // Not used anywhere
    // fromDateMyWAlletText: {
    //     fontSize: "12px",
    //     width: 103,
    //     color: "white"
    // },
    // Not used anywhere
    // fromDateSettlementText: {
    //     fontSize: "12px",
    //     color: "white"
    // },
    toDateMyWAlletText: {
        marginLeft: "6px",
        fontSize: "12px",
        width: 103,
        color: "white"
    },
    // fromImgMyWallet: {
    //     position: "relative",
    //     top: -34,
    //     left: 90
    // },
    // toImgMyWallet: {
    //     position: "relative",
    //     top: -34,
    //     left: 96
    // },
    selectMyWalletPassFloat: {
        fontWeight: "normal",
        fontSize: "14x",
        color: "white",
        top: 37
    },
    selectSettlementFloat: {
        fontWeight: "normal",
        fontSize: "14x",
        color: "white",
        top: 38
    },
    // Not used anywhere
    // catSumName: {
    //     fontSize: 12,
    //     marginTop: 5,
    //     paddingLeft: 12,
    //     fontFamily: "Roboto-Regular",
    //     color: "#4a4a4a"
    // },
    // Not used anywhere
    // catSumAmt: {
    //     fontSize: 12,
    //     marginTop: 5,
    //     fontFamily: "Roboto-Regular",
    //     color: "#4a4a4a"
    // },
    // catSumShowLess: {
    //     fontSize: 12,
    //     fontFamily: "Roboto-Regular",
    //     color: "#5e89c6",
    //     cursor: "pointer",
    //     textAlign: "right"
    // },
    // toggleHead: {
    //     fontFamily: "Roboto-Medium",
    //     fontSize: "12px",
    //     color: "#4a4a4a",
    //     fontWeight: 500
    // },
    // linkWallet: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     color: "#237bfb",
    //     cursor: "pointer"
    // },
    // deleteWallet: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     color: "red",
    //     marginLeft: "20px",
    //     cursor: "pointer"
    // },

    // Used in text field We will remove this later
    textStyleWallet: {
        width: "300px",
        fontSize: 14,
        // fontFamily: "Roboto-Regular",
        fontWeight: 400,
        margin: 0
    },
    // Used in text field We will remove this later
    settleTextFilter: {
        width: "50%",
        fontSize: 14,
        // fontFamily: "Roboto-Regular",
        fontWeight: 400,
        margin: 0
    },
    // Used in text field We will remove this later
    textWalletPlan: {
        width: "120px",
        fontSize: 14,
        // fontFamily: "Roboto-Regular",
        fontWeight: 400,
        margin: 0
    },
    // Used in text field We will remove this later
    floatWallet: {
        fontSize: 12,
        color: "#3c424e"
    },
    // Used in checkbox
    floatChkboxColumn: {
        fontSize: 12,
        color: "#3c424e",
        width: "calc(100%-40px)"
    },
    //Not used anywhere
    // floatTravel: {
    //     fontSize: 12,
    //     color: "#3c424e"
    // },
    //Not used anywhere
    // methodOpertor: {
    //     fontSize: 12,
    //     color: "#4a4a4a",
    //     marginLeft: -90
    // },
    //Not used anywhere
    // navBar: {
    //     marginLeft: "-20px",
    //     textAlign: "center"
    // },
    //Not used anywhere
    // selectedNavFontStyle: {
    //     color: "#FFFFFF",
    //     height: 50,
    //     fontWeight: "bold",
    //     width: 116,
    //     textAlign: "center",
    //     marginTop: 15,
    //     backgroundColor: "blue"
    // },
    //Not used anywhere
    // navFontStyle: {
    //     color: "#FFFFFF",
    //     fontWeight: "bold",
    //     height: 50,
    //     width: 116
    // },
    //Not used anywhere
    // scrollableTableStyle: {
    //     border: "none",
    //     margin: "0px",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 13,
    //     whiteSpace: "normal",
    //     textAlign: "left",
    //     overflow: "scroll",
    //     maxHeight: "calc(100vh - 160px)" // avoid using calc it comes with some performance cost
    // },

    tableStyle: {
        border: "none",
        margin: "0px",
        // fontFamily: "Roboto-Regular",
        fontWeight: 400,
        fontSize: 13,
        whiteSpace: "normal",
        textAlign: "left"
    },
    tableStyleAllowance: {
        border: "1px solid #ddd",
        margin: "0px",
        // fontFamily: "Roboto-Regular",
        fontSize: 13,
        fontWeight: 400,
        whiteSpace: "normal",
        textAlign: "left"
    },
    headerStyle: {
        whiteSpace: "normal",
        border: "none",
        // fontFamily: "Roboto-Medium",
        fontSize: 12,
        fontWeight: 400,
        backgroundColor: "#fcfcfc",
        color: "#0b1322"
    },
    containerStyle: {
        whiteSpace: "normal",
        border: "none",
        // fontFamily: "Roboto-Regular",
        fontSize: 14,
        fontWeight: 400
    },
    //Not used anywhere
    // pageStyleFullPage: {
    //     maxHeight: "92vh",
    //     overflow: "auto",
    //     margin: 0
    // },
    //Not used anywhere
    // pageStyleForMedium: {
    //     maxHeight: "calc(100vh - 116px)",
    //     overflow: "auto"
    // },
    //Not used anywhere
    // bodyStyleForBootStrapTableMedium: {
    //     maxHeight: "67vh"
    // },
    //Not used anywhere
    // tableStyleForBootStrapTableMedium: {
    //     maxHeight: "83vh"
    // },
    //Not used anywhere
    // pageStyleWithHeader: {
    //     maxHeight: "84vh",
    //     overflow: "auto",
    //     margin: 0
    // },
    //Not used anywhere
    // bodyStyleForBootStrapTableFullPage: {
    //     maxHeight: "74vh"
    // },
    //Not used anywhere
    // tableStyleForBootStrapTableFullPage: {
    //     maxHeight: "83vh"
    // },
    //Not used anywhere
    // bodyStyleForBootStrapTableWithHeader: {
    //     maxHeight: "63vh"
    // },
    //Not used anywhere
    // tableStyleForBootStrapTableWithHeader: {
    //     // calc(100vh - 109px);
    //     maxHeight: "73vh"
    // },
    //Not used anywhere
    // sideNavButtonStyle: {
    //     whiteSpace: "normal",
    //     border: "none",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     color: "#606060",
    //     fontWeight: "400",
    //     paddingLeft: 5
    // },
    //Not used anywhere
    // minheaderRowStyle: {
    //     height: 25,
    //     fontSize: 12,
    //     backgroundColor: "#e0e0e0",
    //     color: "#606060",
    //     padding: "0px 10px 0px 0px"
    // },
    //Not used anywhere
    // minheaderRowTextStyle: {
    //     whiteSpace: "normal",
    //     lineHeight: "10px",
    //     border: "none",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     color: "#606060",
    //     fontWeight: "normal",
    //     padding: "5"
    // },
    //Not used anywhere
    // middleHeaderRowStyle: {
    //     height: 60,
    //     fontSize: 14,
    //     fontFamily: "Roboto-Regular",
    //     fontWeight: "normal",
    //     backgroundColor: "#FFFFFF",
    //     color: "#77ADFC"
    // },
    //Not used anywhere
    // middleRightHeaderStyle: {
    //     display: "flex"
    // },
    //Not used anywhere
    // middleRighHeaderContent: {
    //     margin: "4%",
    //     marginLeft: "-1%",
    //     marginLeft: "-4%"
    // },
    //Not used anywhere
    // mainHeaderStyle: {
    //     height: 40,
    //     fontFamily: "Roboto-Regular",
    //     fontWeight: "bold",
    //     backgroundColor: "#373737",
    //     boxShadow: "0px 2px 3px 0px rgba(0,0,0,0.1)",
    //     padding: "0px 10px 0px 0px",
    //     fontSize: 16,
    //     position: "relative"
    // },
    //Not used anywhere
    // navLinkStyle: {
    //     width: 130,
    //     textAlign: "center",
    //     lineHeight: "40px",
    //     fontSize: 14,
    //     fontFamily: "Roboto-Regular"
    // },
    //Not used anywhere
    // leftMenu: {
    //     width: "17%"
    // },
    // mainDisplay: {
    //     // width:'80%'
    // },
    // errorField: {
    //     borderBottom: "1px solid red",
    //     marginBottom: "45px"
    // },
    // correctField: {
    //     borderBottom: "1px solid transparent",
    //     marginBottom: "45px"
    // },
    //Not used anywhere
    // dialogTransaction: {
    //     padding: "10px",
    //     height: "100%"
    // },
    // actionButtonLightBox: {
    //     height: 35,
    //     width: 35,
    //     verticalAlign: "middle",
    //     marginTop: 3,
    //     padding: 5,
    //     cursor: "pointer",
    //     position: "relative"
    // },
    //Not used anywhere
    // actionButtonLightPaginationBox: {
    //     backgroundColor: "#EFEFEF",
    //     height: 35,
    //     width: 35,
    //     verticalAlign: "middle",
    //     marginTop: 3,
    //     padding: 5,
    //     cursor: "pointer"
    // },
    //Not used anywhere
    // actionIconLightBox: {
    //     height: 35,
    //     width: 35,
    //     verticalAlign: "middle",
    //     marginTop: 3,
    //     padding: 5
    // },
    //Not used anywhere
    // actionIconLightBoxForEmp: {
    //     height: 35,
    //     width: 35,
    //     verticalAlign: "middle",
    //     marginTop: 3,
    //     padding: 5,
    //     fontSize: 20
    // },
    actionButtonPagination: {
        verticalAlign: "middle",
        fontSize: 12,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    // actionFlatButton: {
    //     width: "18px",
    //     height: "18px",
    //     lineHeight: 0,
    //     minWidth: "0px",
    //     borderRadius: 2,
    //     backgroundColor: "#ffffff",
    //     border: "1px solid #e8edf4",
    //     margin: "0px 6px 0px 0px",
    //     padding: 0
    // },
    // employeeDashboardStyle: {
    //     iconStyle: {
    //         width: "24px",
    //         margin: "8px 0px",
    //         top: "-3px",
    //         left: "4px"
    //     },
    //     fileSelector: {
    //         cursor: "pointer",
    //         position: "absolute",
    //         top: "0px",
    //         opacity: 0,
    //         width: "0px",
    //         height: "0px"
    //     },
    //     dashboardLeftContainer: {
    //         overflowY: "scroll",
    //         overflowX: "hidden",
    //         height: "100vh",
    //         width: "200px",
    //         marginLeft: "11px",
    //         marginRight: "0px"
    //     },
    //     dashboardPaperStyle: {
    //         textAlign: "center",
    //         width: "100%",
    //         // boxShadow:'0 -2px 3px 0 rgba(0, 0, 0, 0.12)',
    //         height: "86%"
    //     },
    //     dashboardRolesection: {
    //         textAlign: "left",
    //         marginLeft: "14px",
    //         fontSize: "14px",
    //         fontFamily: "Roboto-Regular"
    //     },
    //     dashboardShowMore: {
    //         backgroundColor: "#E8E8E8",
    //         cursor: "pointer",
    //         fontSize: "12px",
    //         color: "blue",
    //         fontFamily: "Roboto-Light",
    //         height: "25px",
    //         paddingTop: "5px"
    //     },
    //     detailStatus: {
    //         display: "inline-block",
    //         fontSize: "12px"
    //     },
    //     detailComplete: {
    //         color: "#C9C9C9"
    //     },
    //     detailInComplete: {
    //         color: "#FFBA00"
    //     },
    //     dashboardReportSubmission: {
    //         height: "90px",
    //         textAlign: "center",
    //         paddingTop: "10px",
    //         cursor: "pointer",
    //         borderRadius: "10px"
    //     },
    //     widgetItems: {
    //         fontSize: "11px"
    //     },
    //     commonRegularStyle: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "14px"
    //     },
    //     commonWishStyle: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "12px",
    //         color: "#0b1322"
    //     },
    //     commonLightStyle: {
    //         fontFamily: "Roboto-Light",
    //         fontSize: "14px",
    //         lineHeight: "20px"
    //     },
    //     commonMediumStyle: {
    //         fontFamily: "Roboto-Medium",
    //         fontSize: "14px",
    //         color: "#373737"
    //     },
    //     dashboardWidgetHeader: {
    //         fontFamily: "Roboto-Medium",
    //         fontSize: "14px",
    //         marginBottom: "15px"
    //     },
    //     dashboardSubmitReport: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "14px"
    //     }
    // },
    help: {
        commonBtnStyle: {
            color: "#ffffff",
            // fontFamily: "Roboto-Medium",
            fontWeight: 500,
            fontSize: 12,
            width: 180,
            borderRadius: "8px",
            height: 30,
            paddingTop: 8,
            textAlign: "center",
            margin: "0 auto",
            cursor: "pointer",
            position: "absolute",
            bottom: 12
        },
        eachpageBtnStyle: {
            color: "#ffffff",
            // fontFamily: "Roboto-Medium",
            fontWeight: 500,
            fontSize: 14,
            borderRadius: "8px",
            height: 40,
            paddingTop: 10,
            margin: "0 auto",
            cursor: "pointer"
        },
        selectableHelpStyle: {
            // fontFamily: "Roboto-Medium,sans-serif",
            fontWeight: 500,
            border: 10,
            boxSizing: "border-box",
            display: "block",
            cursor: "pointer",
            textDecoration: "none",
            margin: 0,
            padding: 0,
            outline: "none",
            fontSize: 12,
            borderRight: "4px solid #237bfb",
            fontWeight: "inherit",
            transform: "translate(0px, 0px)",
            verticalAlign: "middle",
            color: "#237bfb",
            position: "relative",
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
            backgroundColor: "#f6f6f6"
        },
        eachListStyle: {
            fontSize: 12,
            // fontFamily: "Roboto-Regular",
            fontWeight: 400,
            color: "#4a4a4a",
            height: 50,
            padding: 0
            // borderBottom:'1px solid #ccc',
        }
    },
    adminDashboardStyle: {
        // iconElementStyle: {
        //     border: "1px solid white",
        //     color: "#ffffff",
        //     backgroundColor: "#77ADFC",
        //     margin: "20px",
        //     borderRadius: "20px",
        //     padding: "4px",
        //     cursor: "pointer"
        // },
        // commonMediumStyle: {
        //     fontFamily: "Roboto-Medium",
        //     fontSize: "14px",
        //     color: "#4a4a4a"
        // },
        // commonRegularStyle: {
        //     fontFamily: "Roboto-Regular",
        //     fontSize: "14px",
        //     color: "#4a4a4a"
        // },
        // commonLightStyle: {
        //     fontFamily: "Roboto-Light",
        //     fontSize: "14px",
        //     color: "#606060"
        // },
        selectableStyle: {
            // fontFamily: "Roboto-Medium",
            fontWeight: 500,
            border: 10,
            boxSizing: "border-box",
            display: "block",
            cursor: "pointer",
            textDecoration: "none",
            margin: 0,
            padding: 0,
            outline: "none",
            fontSize: 14,
            fontWeight: "inherit",
            transform: "translate(0px, 0px)",
            verticalAlign: "middle",
            color: "#ffffff",
            position: "relative",
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
            backgroundColor: "#33ABFF"
        },
        selectableTabStyle: {
            // fontFamily: "Roboto-Medium,sans-serif",
            fontWeight: 500,
            border: 10,
            boxSizing: "border-box",
            display: "block",
            cursor: "pointer",
            textDecoration: "none",
            margin: 0,
            padding: 0,
            outline: "none",
            fontSize: 12,
            borderLeft: "4px solid #5ccf78",
            fontWeight: "inherit",
            transform: "translate(0px, 0px)",
            verticalAlign: "middle",
            color: "#ffffff",
            position: "relative",
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
            backgroundColor: "#fafafa"
        },
        selectableTabEmpStyle: {
            // fontFamily: "Roboto-Medium,sans-serif",
            border: 10,
            boxSizing: "border-box",
            display: "block",
            cursor: "pointer",
            textDecoration: "none",
            margin: 0,
            padding: "12px 0px",
            outline: "none",
            fontSize: 12,
            borderLeft: "4px solid #5ccf78",
            fontWeight: 500,
            transform: "translate(0px, 0px)",
            verticalAlign: "middle",
            color: "#ffffff",
            position: "relative",
            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
            backgroundColor: "#fafafa"
        }
        // adhocButtonStyle: {
        //     padding: "6px 12px",
        //     width: 200,
        //     textAlign: "center",
        //     backgroundColor: "#ffffff",
        //     border: "1px solid #237bfb",
        //     borderRadius: 24,
        //     display: "inline-block",
        //     marginRight: 4,
        //     fontFamily: "Roboto-Regular",
        //     color: "#606060",
        //     fontSize: 14,
        //     cursor: "pointer"
        // },
        // actionBtn1: {
        //     padding: 3,
        //     width: 100,
        //     textAlign: "center",
        //     color: "#ffffff",
        //     backgroundColor: "#B9BFCE",
        //     borderTopLeftRadius: "4em",
        //     borderBottomLeftRadius: "4em",
        //     display: "inline-block",
        //     cursor: "pointer"
        // },
        // actionBtn2: {
        //     padding: "3px 12px",
        //     width: 100,
        //     textAlign: "center",
        //     color: "#ffffff",
        //     backgroundColor: "#237bfb",
        //     borderTopRightRadius: "4em",
        //     borderBottomRightRadius: "4em",
        //     display: "inline-block",
        //     cursor: "pointer"
        // }
    },
    etlPageStyle: {
        // titleStyle: {
        //     color: "#237BFB",
        //     fontFamily: "Roboto-Medium",
        //     fontSize: 16,
        //     marginBottom: 9
        // },
        // cardAction: {
        //     fontFamily: "Roboto-Medium",
        //     fontSize: 14,
        //     color: "#237BFB",
        //     cursor: "pointer"
        // },
        // etlCardText: {
        //     display: "inline-block",
        //     borderRight: "1px solid #e3e3e3",
        //     width: "424px",
        //     padding: 16,
        //     height: "100%"
        // },
        etlCardStyle: {
            height: "auto",
            marginLeft: "0px",
            width: 500,
            marginLeft: 25,
            marginBottom: 20
        },
        // eachHeading: {
        //     fontFamily: "Roboto-Regular",
        //     fontSize: 12,
        //     color: "#51668E",
        //     margin: "10px 0px"
        // },
        // mailHeader: {
        //     fontFamily: "Roboto-Medium",
        //     fontSize: 14,
        //     color: "#606060",
        //     display: "inline-block",
        //     marginRight: 10,
        //     textTransform: "capitalize"
        // },
        // subDiv: {
        //     marginBottom: 25
        // },
        // eachsubDiv: {
        //     marginLeft: 25
        // },
        // columnHeader: {
        //     fontFamily: "Roboto-Medium",
        //     fontSize: 14,
        //     color: "#606060"
        // },
        floatingLabelETL: {
            fontSize: 14,
            // fontFamily: "Roboto-Light",
            fontWeight: 300,
            color: "#606060"
        },
        // fieldValue: {},
        frequencyRadio: {
            // fontFamily: "Roboto-Regular",
            fontWeight: 400,
            fontSize: 14,
            color: "#606060"
        },
        // approvedAmoutTxtField: {
        //     fontFamily: "Roboto-Regular",
        //     fontSize: 14,
        //     color: "#606060",
        //     width: 120
        // },
        footerStyle: {
            position: "fixed",
            bottom: 0,
            background: "#ffffff",
            width: 800,
            height: 46,
            padding: "4px 8px",
            textAlign: "right",
            borderTop: "1px solid #e3e3e3",
            zIndex: 1
        }
    },
    // AuthorizeTransaction: {
    //     // padding10: {
    //     //     padding: 10
    //     // },
    //     // height100: {
    //     //     height: "100%"
    //     // },
    //     // regular18Font: {
    //     //     fontFamily: "Roboto-Regular",
    //     //     fontSize: "18px"
    //     // },
    //     regularLight14Font: {
    //         fontFamily: "Roboto-Light",
    //         fontSize: "14px"
    //     },
    //     bodyStyle: {
    //         backgroundColor: "#FFFFFF",
    //         padding: "10px 20px"
    //     },
    //     // actionStyle: {
    //     //     backgroundColor: "#E9EDEE",
    //     //     padding: "0 4px"
    //     // },
    //     // equalDiv: {
    //     //     height: "100%",
    //     //     textAlign: "center"
    //     // }
    // },
    // Not used anywhere
    // floatRight: {
    //     float: "right"
    // },
    // Not used anywhere
    // backButton: {
    //     backgroundColor: "#89B8FC",
    //     borderRadius: "50%"
    // },
    // Will remove this later
    whiteColor: {
        color: "#fff"
    },
    // Will remove this later
    floatingLabelStyle: {
        fontSize: "14px",
        fontWeight: "normal",
        padding: "0px"
    },
    // Will remove this later
    floatingUnderLineStyle: {
        color: "#237bfb"
    },
    // hintMsg: {
    //     fontStyle: "italic",
    //     color: "",
    //     fontSize: 12
    // },
    // chipWrapper: {
    //     minHeight: 48,
    //     padding: "12px 16px 4px 16px",
    //     display: "flex",
    //     flexWrap: "wrap",
    //     borderTop: "1px solid #eef2f7",
    //     borderBottom: "1px solid #eef2f7"
    // },
    // Will replace later
    indvChip: {
        margin: "0px 8px 8px 0px",
        border: "1px solid #e8edf4",
        borderRadius: "3px",
        backgroundColor: "white"
    },
    chipLableStyle: {
        color: "#0b1322",
        padding: "5px 10px",
        fontSize: 12,
        lineHeight: "14px",
        display: "inherit",
        cursor: "pointer"
    },
    deleteIconStyle: {
        height: 14,
        width: 14,
        fill: "#0b1322"
    },
    // indvLabelStyle: {
    //     fontSize: 12,
    //     color: "#0b1322",
    //     fontWeight: 500,
    //     fontFamily: "Roboto-Medium",
    //     lineHeight: 2,
    //     margin: "0px 8px"
    // },
    // Not used anywhere

    // walletMenuStyle: {
    //     width: "170px",
    //     objectFit: "contain",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     fontStretch: "normal",
    //     display: "inline-block",
    //     color: "#237bfb"
    // },
    // Not used anywhere
    // walletMenuStyle2: {
    //     width: "170px",
    //     objectFit: "contain",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     fontStretch: "normal",
    //     color: "#606060",
    //     display: "inline-block",
    //     marginRight: 25
    // },
    // Not used anywhere
    // walletMenuIconBackGround: {
    //     width: "260px",
    //     height: "80px",
    //     background: "#297ffc",
    //     borderRadius: "40px"
    // },
    // Not used anywhere
    // walletIconStyle: {
    //     fontWeight: "900",
    //     color: "#FFFFFF"
    // },
    // SearchBar: {
    //     WrapperDiv: {
    //         fontSize: "14px",
    //         background: "rgba(249, 249, 249, 0.7)",
    //         padding: "0px 11px 11px",
    //         fontFamily: "Roboto-Regular",
    //         fontWeight: 500,
    //         color: "#3c424e"
    //     }
    // },
    // SetSearchButton: {
    //     SetSearchButtonBackground: "#f5f5f5",
    //     SetSearchButtonStyle: {
    //         color: "#f5f5f5",
    //         fontSize: "12px",
    //         height: "22px",
    //         lineHeight: "18px",
    //         border: "1px solid #5ccf78",
    //         borderRight: "0",
    //         mxWidth: "90px",
    //         borderRadius: "50px 5px 5px 50px",
    //         textTransform: "capitalize"
    //     },
    //     SetSearchButtonBtnStyle: {
    //         color: "#f5f5f5",
    //         height: "22px",
    //         lineHeight: "18px",
    //         border: "1px solid #5ccf78",
    //         borderRight: "0",
    //         mxWidth: "90px",
    //         borderRadius: "50px 5px 5px 50px"
    //     },
    //     SetSearchButtonLabelStyle: {
    //         color: "#000000",
    //         padding: "0px 8px",
    //         textTransform: "capitalize"
    //     }
    // },
    // ClearSearchButton: {
    //     ClearSearchButtonBackground: "#f5f5f5",
    //     ClearSearchButtonStyle: {
    //         color: "#f5f5f5",
    //         fontSize: "12px",
    //         height: "22px",
    //         lineHeight: "18px",
    //         mxWidth: "90px",
    //         border: "1px solid #4a4a4a",
    //         borderRadius: "5px 50px 50px 5px",
    //         textTransform: "capitalize"
    //     },
    //     ClearSearchButtonBtnStyle: {
    //         color: "#f5f5f5",
    //         height: "22px",
    //         lineHeight: "18px",
    //         mxWidth: "90px",
    //         border: "1px solid #4a4a4a",
    //         borderRadius: "5px 50px 50px 5px"
    //     },
    //     ClearSearchButtonLabelStyle: {
    //         color: "#000000",
    //         padding: "0px 8px",
    //         textTransform: "capitalize"
    //     }
    // },
    // cardLoadTemplateIcon: {
    //     width: "36px",
    //     height: "76px",
    //     padding: 0,
    //     right: 16,
    //     bottom: "16px",
    //     backgroundColor: "#f9f9f9"
    // },
    // cardLoadTemplateLabel: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "16px",
    //     color: "#237bfb",
    //     verticalAlign: "top"
    // },
    // WFNotification: {
    //     backgroundColor: "#f9f9f9",
    //     margin: "12px 12px 0px 0px",
    //     padding: "5px 12px 5px 26px"
    // },
    // Will replace laterr used in Textfield
    WfNotifyFloat: {
        height: "13px",
        fontSize: "14px",
        color: "#606060",
        fontWeight: "normal"
    },
    // WfNotifyText: {
    //     width: "170px",
    //     fontSize: "16px",
    //     color: "#606060"
    // },
    // cardLoadTemplateDiv: {
    //     marginLeft: "35px",
    //     marginTop: "-44px",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     color: "#4a4a4a"
    // },
    configDivider: {
        position: "relative",
        marginTop: "10px",
        marginLeft: "-16px"
    },
    // Not used anywhere
    // searchMyWalletSubmit: {
    //     position: "relative",
    //     bottom: -33,
    //     right: 100,
    //     borderRadius: 100,
    //     backgroundColor: "#237bfb",
    //     border: "solid 1px #ffffff"
    // },
    // Not used anywhere
    // travelConfigCss: {
    //     chip: {
    //         margin: 4
    //     },
    //     errorStyle: {
    //         color: Colors.orange500
    //     },
    //     cancelButtonStyle: {
    //         backgroundColor: "#ffffff",
    //         color: "black"
    //     },
    //     saveButtonStyle: {
    //         backgroundColor: "#77ADFC",
    //         color: "white"
    //     }
    // },
    // Not used anywhere
    // FileIcon: {
    //     display: "table-cell",
    //     verticalAlign: "middle"
    // },
    editUserProfile: {
        // Used in CHIP
        chip: {
            margin: 4
        }
        // wrapper: {
        //     display: "flex",
        //     flexWrap: "wrap"
        // }
    },

    // Used in commented code
    // recurringTransfer: {
    //     headers: {
    //         width: "117px",
    //         height: "11px",
    //         opacity: 0.7,
    //         fontFamily: "Roboto",
    //         fontSize: "12px",
    //         fontWeight: "normal",
    //         fontStyle: "normal",
    //         fontStretch: "normal",
    //         letterSpacing: "0.3px",
    //         textAlign: "left",
    //         color: "#4a4a4a"
    //     },
    //     content: {
    //         height: "16px",
    //         fontFamily: "Roboto",
    //         fontSize: "14px",
    //         fontWeight: "normal",
    //         fontStyle: "normal",
    //         fontStretch: "normal",
    //         letterSpacing: "0.4px",
    //         textAlign: "left",
    //         color: "#4a4a4a"
    //     }
    // },
    // Not used anywhere
    // modifyBtn: {
    //     style: {
    //         borderRadius: "100px",
    //         transition: "none !important",
    //         transform: "none !important",
    //         cursor: "pointer",
    //         border: "1px solid #ffffff",
    //         textTransform: "capitalize",
    //         lineHeight: "25px",
    //         height: "27px",
    //         color: "#ffffff",
    //         marginRight: 10
    //     },
    //     labelStyle: {
    //         textTransform: "capitalize"
    //     },
    //     backgroundColor: "#237BFB"
    // },
    // Not used anywhere
    // modifyEmpBtn: {
    //     style: {
    //         borderRadius: "100px",
    //         transition: "none !important",
    //         transform: "none !important",
    //         cursor: "pointer",
    //         border: "1px solid #237bfb",
    //         textTransform: "capitalize",
    //         lineHeight: "25px",
    //         height: "27px",
    //         color: "#237bfb",
    //         marginRight: 10
    //     },
    //     labelStyle: {
    //         textTransform: "capitalize"
    //     },
    //     backgroundColor: "transparent"
    // },
    // Not used anywhere
    // settleFilterBtn: {
    //     style: {
    //         borderRadius: "100px",
    //         transition: "none !important",
    //         transform: "none !important",
    //         cursor: "pointer",
    //         border: "1px solid #5CCF78",
    //         textTransform: "capitalize",
    //         lineHeight: "25px",
    //         height: "27px",
    //         color: "#000",
    //         marginRight: 10
    //     },
    //     labelStyle: {
    //         textTransform: "capitalize"
    //     },
    //     backgroundColor: "transparent"
    // },

    // walletsPage: {
    //     blueDiv: { backgroundColor: "#237bfb", padding: 20 },
    //     title: { fontFamily: "Roboto-Regular", fontWeight: "bold", color: "white" },
    //     filterDiv: { marginTop: "-20px", padding: "0 18px" },
    //     table: { backgroundColor: "white", border: "1px solid #F3F3F3", borderRadius: 3 },
    //     tableNoBorder: { backgroundColor: "white", border: "1px solid #F3F3F3" },
    //     breakdownWrapper: { width: "95%", margin: "0 auto", marginTop: -30 },
    //     paginationDiv: { backgroundColor: "white", height: 30, fontSize: 12, marginTop: 15 },
    //     paginationDivEmp: {
    //         backgroundColor: "white",
    //         height: 30,
    //         fontSize: 12,
    //         padding: "0 5px",
    //         borderTopLeftRadius: 3,
    //         borderTopRightRadius: 3
    //     }
    // },
    // Not used anywhere
    // kycStatus: {
    //     illustration: {
    //         width: 230,
    //         height: 230,
    //         backgroundRepeat: "no-repeat",
    //         backgroundPosition: "50%",
    //         backgroundColor: "#ffffff",
    //         borderRadius: 115,
    //         border: "2px solid #fff",
    //         boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.23)",
    //         backgroundImage: "url(/assets/images/KYC_illus.svg)"
    //     },
    //     wrapper: {
    //         backgroundColor: "#fff",
    //         padding: "50px 0"
    //     },
    //     verticalLine: {
    //         border: "1px solid #fff",
    //         height: 250,
    //         width: 1,
    //         position: "absolute",
    //         top: "230px",
    //         left: "50%"
    //     },
    //     imgWrapper: {
    //         width: 72,
    //         height: 72,
    //         backgroundColor: "#ffffff",
    //         backgroundRepeat: "no-repeat",
    //         backgroundPosition: "50%",
    //         borderRadius: 36,
    //         margin: "0 auto",
    //         border: "1px solid #fff",
    //         boxShadow: " 0 2px 4px 0 rgba(0, 0, 0, 0.23)"
    //     },
    //     poiImgWrapper: {
    //         backgroundImage: "url(/assets/images/profile.svg)"
    //     },
    //     poaImgWrapper: {
    //         backgroundImage: "url(/assets/images/location.svg)"
    //     },
    //     poiImg: {
    //         width: 72,
    //         height: 72,
    //         borderRadius: 36,
    //         background: "#ffffff",
    //         border: "1px solid #fff",
    //         boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.2)",
    //         cursor: "pointer",
    //         backgroundRepeat: "no-repeat",
    //         backgroundPosition: "50%"
    //     },
    //     cta: {
    //         position: "absolute",
    //         top: "35%",
    //         right: "5%"
    //     },
    //     helpText: {
    //         position: "absolute",
    //         top: "35%",
    //         left: 0
    //     }
    // },
    // Not used anywhere

    // bookings: {
    //     stopLabel: {
    //         fontFamily: "Roboto-Light",
    //         fontSize: 11,
    //         color: "#3c424e",
    //         lineHeight: 1.33,
    //         letterSpacing: "0.7px"
    //     },
    //     cityhint: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: 13,
    //         fontStyle: "italic",
    //         lineHeight: 1.46,
    //         letterSpacing: "0.6px",
    //         color: "rgba(74, 74, 74, 0.6)"
    //     },
    //     floatinglabel: {
    //         color: "#ffffff",
    //         fontFamily: "Roboto-Regular"
    //     },
    //     inputtext: {
    //         fontFamily: "Roboto-Medium",
    //         fontSize: 13,
    //         textAlign: "left",
    //         letterSpacing: "0.5px"
    //     },
    //     airportmenu: {
    //         borderBottom: "1px solid #cfcfcf",
    //         padding: "8px 0px"
    //     },
    //     bookingTab: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: 14,
    //         fontWeight: 500,
    //         textAlign: "center",
    //         color: "#3c424e",
    //         cursor: "pointer",
    //         margin: "14px auto",
    //         borderRight: "solid 1px #e8edf4"
    //     },
    //     mybookinglist: {
    //         fontSize: 14,
    //         padding: 0,
    //         fontFamily: "Roboto-Medium",
    //         backgroundColor: "#ffffff",
    //         borderRadius: 3,
    //         boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.12)",
    //         borderStyle: "solid",
    //         borderWidth: 0.5,
    //         borderImageSource:
    //             "linear-gradient(to bottom, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0) 80%, rgba(0, 0, 0, 0.02) 95%, rgba(0, 0, 0, 0.04))",
    //         borderImageSlice: 1
    //     },
    //     nestedlist: {
    //         padding: "8px 16px",
    //         color: "#606060",
    //         backgroundColor: "#ffffff"
    //     },
    //     itinerary_infoIcon: {
    //         width: 13,
    //         height: 13,
    //         verticalAlign: "bottom",
    //         marginLeft: 14
    //     },
    //     labelField: {
    //         color: "red !important"
    //     },
    //     titleField: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "12px",
    //         width: 94,
    //         textAlign: "left",
    //         color: "#3c424e",
    //         margin: "-24px 20px 0px 25px"
    //     },
    //     titleDay: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "12px",
    //         width: 94,
    //         textAlign: "left",
    //         color: "#3c424e"
    //     },
    //     titleMonth: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "12px",
    //         width: 150,
    //         textAlign: "left",
    //         color: "#3c424e",
    //         margin: "0px 20px"
    //     },
    //     titleYear: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "12px",
    //         width: 150,
    //         textAlign: "left",
    //         color: "#3c424e",
    //         margin: "0px -7px"
    //     },
    //     travelName: {
    //         width: 150,
    //         height: 32,
    //         padding: 12,
    //         color: "#3c424e",
    //         fontSize: 14,
    //         margin: "0px 12px 0px 0px",
    //         borderRadius: 2,
    //         border: "solid 1px #e8edf4"
    //     },
    //     travelStar: {
    //         margin: "0px -5px 7px"
    //     },
    //     contactText: {
    //         width: 150,
    //         height: 32,
    //         padding: 12,
    //         display: "inline-block",
    //         margin: "-7px 12px 0px 0px",
    //         color: "#3c424e",
    //         borderRadius: 2,
    //         border: "solid 1px #e8edf4"
    //     },
    //     contactEmail: {
    //         width: 289,
    //         height: 32,
    //         padding: 12,
    //         display: "inline-block",
    //         color: "#3c424e",
    //         margin: "-7px 12px 0px 0px",
    //         borderRadius: 2,
    //         border: "solid 1px #e8edf4"
    //     },
    //     check: {
    //         display: "inline-flex",
    //         padding: "0px 9px"
    //     },
    //     check_manage: {
    //         display: "inline-flex",
    //         padding: "0px 6px"
    //     },
    //     book_pend_clock: {
    //         display: "inline-flex",
    //         padding: "12px 6px"
    //     },
    //     wallet: {
    //         display: "inline-flex",
    //         marginLeft: "20px"
    //     },
    //     walletRad: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: "14px",
    //         textAlign: "left",
    //         color: "#3c424e"
    //     },
    //     checkPri: {
    //         fontFamily: "Roboto-Light",
    //         fontSize: "10px",
    //         textAlign: "left",
    //         color: "#3c424e",
    //         margin: "-3px",
    //         width: "auto"
    //     }
    // },
    // Not used anywhere
    // flightLoader: {
    //     display: "inline-block",
    //     margin: 0,
    //     paddingTop: "15%",
    //     position: "absolute",
    //     top: 0,
    //     width: "100%",
    //     height: "2000px",
    //     zIndex: 3000,
    //     backgroundColor: "#000000",
    //     opacity: 0.5,
    //     textAlign: "center"
    // },
    // Not used anywhere
    // textStylePayHistory: {
    //     width: "200px",
    //     fontSize: 13,
    //     fontFamily: "Roboto-Regular",
    //     margin: 0
    // },
    // replace this later
    floatPayHistory: {
        fontSize: 13,
        color: "#ffffff"
    },
    // Not used anywhere
    // fromDatePayHistoryText: {
    //     fontSize: "12px",
    //     color: "white"
    // },
    // walletcurrentBal: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     fontWeight: "normal",
    //     textAlign: "left",
    //     color: "#3c424e"
    // },
    // walletcurrentBalDisbaled: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: 12,
    //     fontWeight: "normal",
    //     textAlign: "left",
    //     color: "#868484"
    // },
    // use this to style the menuitem look smaller and neater
    menuItemStyle: {
        fontSize: 13,
        // fontFamily: "Roboto-Regular",
        fontWeight: 400,
        minHeight: 0,
        lineHeight: 2,
        opacity: 0.8,
        color: "#2a436a",
        float: "unset",
        position: "relative",
        padding: "2px 0px"
    },
    // Not used anywhere
    // draftmenuItemStyle: {
    //     fontSize: 13,
    //     fontFamily: "Roboto-Regular",
    //     minHeight: 0,
    //     lineHeight: 2,
    //     opacity: 0.8,
    //     color: "#2a436a",
    //     float: "unset",
    //     position: "relative",
    //     padding: "2px 0px"
    // },
    searchAbleMenuItem: {
        fontSize: 12,
        // fontFamily: "Roboto-Regular",
        fontWeight: 400,
        opacity: 1,
        position: "relative"
    },
    // Not used anywhere
    // searchableSelectButton: {
    //     fontSize: 12,
    //     fontFamily: "Arial",
    //     borderRadius: "4px",
    //     outline: "none",
    //     backgroundColor: "#ffffff",
    //     border: "1px solid #dcdcdc",
    //     display: "inline-block",
    //     cursor: "pointer",
    //     color: "#666666",
    //     height: "21px",
    //     marginRight: 6,
    //     textAlign: "center"
    // },
    genericTableClass: {
        primaryTextStyle: {
            color: "#3c424e",
            fontWeight: 400,
            fontSize: "12px",
            cursor: "pointer"
        },
        primaryTextStyleCapital: {
            color: "#0b1322",
            fontWeight: 500,
            textTransform: "capitalize",
            fontSize: "14px",
            cursor: "pointer"
        },
        secondaryTextStyle: {
            color: "#3c424e",
            // fontWeight: 300,
            fontSize: "10px",
            marginRight: "5px",
            cursor: "pointer"
        },
        secondaryText: {
            color: "#3c424e",
            fontWeight: 300,
            fontSize: "10px",
            marginRight: "5px",
            cursor: "pointer"
        },
        statusStyle: {
            fontWeight: 400,
            fontSize: "12px",
            borderRadius: "2px",
            padding: "4px 2px",
            textAlign: "center",
            maxWidth: "90px",
            cursor: "pointer"
        },
        statusStyleCommon: {
            fontWeight: 400,
            fontSize: "12px",
            borderRadius: "2px",
            padding: "4px 2px",
            textAlign: "center",
            maxWidth: "90px"
        },
        primaryTextStyleCommon: {
            color: "#3c424e",
            fontWeight: 400,
            fontSize: "12px"
        },
        secondaryTextStyleCommon: {
            color: "#3c424e",
            fontWeight: 300,
            fontSize: "10px",
            marginRight: "5px"
        }
    },
    // drawerheader: {
    //     display: "inline-block",
    //     textTransform: "uppercase",
    //     fontFamily: "Roboto-Medium",
    //     fontSize: "14px",
    //     height: "16px",
    //     fontWeight: 500,
    //     color: "#3c424e",
    //     marginLeft: "16px"
    // },
    // drawerActionButton: {
    //     backgroundColor: "#fff",
    //     borderRadius: "2px",
    //     color: "#5e89c6",
    //     fontSize: "12px",
    //     fontWeight: 500,
    //     letterSpacing: "0.4px",
    //     textAlign: "center",
    //     fontFamily: "Roboto-Medium",
    //     marginRight: "20px"
    // },
    // drawerActionDeleteButton: {
    //     backgroundColor: "#fff",
    //     borderRadius: "2px",
    //     color: "#f45d5d",
    //     fontSize: "12px",
    //     fontWeight: 500,
    //     letterSpacing: "0.4px",
    //     textAlign: "center",
    //     fontFamily: "Roboto-Medium",
    //     marginRight: "20px"
    // },
    // creationIconWrapper: {
    //     backgroundColor: "#f7f9fb",
    //     display: "inline-block",
    //     width: "100%",
    //     height: "calc(100vh - 190px)",
    //     fontFamily: "Roboto-Medium",
    //     textAlign: "center"
    // },
    // innerCreationIconWrapper: {
    //     backgroundColor: "#fff",
    //     height: "55vh",
    //     margin: "80px",
    //     // border:"1px solid #5e89c6",
    //     // borderStyle: "dashed",
    //     // borderRadius:"5px",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     flexDirection: "column"
    // },

    // billWrapper: {
    //     backgroundColor: "#f7f9fb",
    //     display: "inline-block",
    //     width: "100%",
    //     height: "241px",
    //     margin: "0px auto",
    //     fontFamily: "Roboto-Medium",
    //     // fontSize:16,
    //     // color:'#4a4a4a',
    //     textAlign: "center"
    // },
    // innerBillWrapper: {
    //     backgroundColor: "#fff",
    //     height: "180px",
    //     // margin :"25px 30px",
    //     margin: "30px 30px",
    //     border: "1px solid #5e89c6",
    //     borderStyle: "dashed",
    //     borderRadius: "5px",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     flexDirection: "column"
    // },
    // Not used anywhere
    // innerBillWrapperForPDF: {
    //     backgroundColor: "#fff",
    //     height: "180px",
    //     margin: "12px 30px",
    //     border: "1px solid #5e89c6",
    //     borderStyle: "dashed",
    //     borderRadius: "5px",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     flexDirection: "column"
    // },
    // Not used anywhere
    // innerBillWrapperForImage: {
    //     backgroundColor: "#fff",
    //     // height:"180px",
    //     margin: "12px 30px",
    //     border: "1px solid #5e89c6",
    //     borderStyle: "dashed",
    //     borderRadius: "5px",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     flexDirection: "column"
    // },
    // Not used anywhere
    // ImageBillWrapper: {
    //     width: "100%",
    //     verticalAlign: "middle",
    //     padding: "10px",
    //     boxSizing: "content-box"
    // },
    // policyWrapper: {
    //     backgroundColor: "#f7f9fb",
    //     display: "inline-block",
    //     width: "420px",
    //     margin: "30px 30px",
    //     padding: "10px",
    //     fontFamily: "Roboto-Medium",
    //     textAlign: "left",
    //     border: "solid 1px #e8edf4",
    //     borderRadius: "5px",
    //     maxHeight: "200px",
    //     overflowX: "hidden",
    //     overflowY: "scroll"
    // },
    // policyWrapperForDrawer: {
    //     backgroundColor: "#f7f9fb",
    //     display: "inline-block",
    //     width: "420px",
    //     margin: "30px 30px 10px 30px",
    //     padding: "10px",
    //     fontFamily: "Roboto-Medium",
    //     textAlign: "left",
    //     border: "solid 1px #e8edf4",
    //     borderRadius: "5px",
    //     maxHeight: "200px",
    //     overflowX: "hidden",
    //     overflowY: "scroll"
    // },
    // policyIconStyle: {
    //     width: "18px",
    //     height: "18px",
    //     objectFit: "contain",
    //     overflow: "hidden",
    //     cursor: "pointer"
    // },
    // policyIconStyleForDrawer: {
    //     width: "12px",
    //     height: "12px",
    //     objectFit: "contain",
    //     overflow: "hidden",
    //     cursor: "pointer",
    //     margin: "0px 8px 0px 2px"
    // },
    // policyToolTipULStyle: {
    //     listStyleType: "circle",
    //     color: "#0b1322",
    //     fontSize: "11px",
    //     fontFamily: "Roboto-Regular",
    //     fontWeight: 500,
    //     maxWidth: "700px",
    //     paddingLeft: "20px",
    //     paddingRight: "20px",
    //     textAlign: "left"
    // },
    // fixedPortionWrapperStyle: {
    //     position: "fixed",
    //     width: "100%"
    // },
    // fixedPortionStyle: {},
    // Not used anywhere
    // fixedFooterWrapperStyle: {
    //     width: "100%"
    // },

    // addTripWrapper: {
    //     display: "flex",
    //     justifyContent: "center"
    // },
    // Not used anywhere
    // fixedFooterStyle: {
    //     width: "1000px",
    //     position: "fixed",
    //     bottom: 0,
    //     zIndex: 999,
    //     backgroundColor: "#fff",
    //     height: 50,
    //     padding: "6px 2px",
    //     borderTop: "1px solid #eef2f7"
    // },
    // scrollablePortionStyle: {
    //     height: "50vh",
    //     overflowX: "hidden",
    //     overflowY: "scroll",
    //     paddingBottom: "10%"
    // },
    // viewDrawerNativeWrapper: {
    //     maxWidth: "90%"
    // },
    // viewDrawerNativeHeader: {
    //     color: "#0b1322",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     lineHeight: 1.3,
    //     paddingLeft: "30px",
    //     marginTop: "20px",
    //     marginBottom: "6px"
    // },
    // viewDrawerNativeValues: {
    //     color: "#3c424e",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     lineHeight: 1.7,
    //     fontWeight: "normal",
    //     marginLeft: "30px",
    //     borderBottom: "1px solid #e8edf4"
    // },
    // viewDrawerImageHeaderText: {
    //     color: "#0b1322",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     lineHeight: 1.7,
    //     fontWeight: 700
    // },
    // Not used anywhere
    // viewDrawerSplitHeaderText: {
    //     color: "#0b1322",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     lineHeight: 1.7,
    //     fontWeight: 700,
    //     marginLeft: "22px"
    // },
    // Not used anywhere
    // viewDrawerNativeValuesEmpty: {
    //     color: "#0b1322",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     lineHeight: 1.7,
    //     opacity: 0.7,
    //     fontWeight: 700,
    //     marginLeft: "30px",
    //     padding: "20px 0px 2px 0px",
    //     borderBottom: "1px solid #e8edf4"
    // },
    // GenericHeaderImageWrapper: {
    //     display: "inline-block",
    //     marginRight: "15px"
    // },
    // GenericHeaderNameWrapper: {
    //     fontSize: "14px",
    //     fontFamily: "Roboto-Medium",
    //     fontWeight: 500,
    //     color: "#3c424e",
    //     textTransform: "uppercase",
    //     display: "inline-block"
    // },
    // GenericHeaderIDWrapper: {
    //     fontSize: "11px",
    //     fontFamily: "Roboto-Medium",
    //     fontWeight: 500,
    //     color: "#0b1322",
    //     backgroundColor: "#f9f9f9",
    //     borderRadius: "2px",
    //     padding: "4px 0px",
    //     marginTop: "5px",
    //     textAlign: "center"
    // },
    // GenericHeaderFieldWrapper: {
    //     borderLeft: "2px solid #f9f9f9",
    //     borderRight: "2px solid #f9f9f9",
    //     padding: "15px 0px 5px 15px",
    //     marginTop: "0px",
    //     marginBottom: "0px"
    // },
    // Not used anywhere
    // GenericHeaderExtraFieldCollapsedStyle: {
    //     height: "30px",
    //     overflow: "hidden",
    //     transition: "height 2s ease-in-out",
    //     WebkitTransition: "height 2s ease-in-out" /* Safari */
    // },
    // Not used anywhere
    // GenericHeaderExtraFieldExpandedStyle: {
    //     height: "auto",
    //     transition: "height 2s ease-in-out",
    //     WebkitTransition: "height 2s ease-in-out" /* Safari */
    // },
    // Not used anywhere
    // reportCreationHeaderStyle: {
    //     height: "56px",
    //     display: "flex",
    //     alignItems: "center",
    //     width: "1000px"
    // },
    // Not used anywhere
    // expSplitHeaderStyle: {
    //     height: "56px",
    //     display: "flex",
    //     alignItems: "center"
    // },
    // GenericHeaderFieldStyle: {
    //     maxWidth: "300px",
    //     padding: "5px 0px",
    //     lineHeight: 1
    // },
    // GenericHeaderButtonWrapper: {
    //     padding: "8px",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     border: "1px solid rgb(232, 237, 244)",
    //     borderLeft: 0,
    //     cursor: "pointer",
    //     borderRadius: "0px 3px 3px 0px"
    // },
    // GenericHeaderFieldTitleStyle: {
    //     textTransform: "capitalize",
    //     display: "inline-block",
    //     fontSize: "11px",
    //     color: "#0b1322"
    // },
    // GenericHeaderFieldValueStyle: {
    //     marginLeft: "4px",
    //     display: "inline-block",
    //     fontSize: "12px",
    //     color: "#3c424e",
    //     fontFamily: "Roboto-Regular"
    // },
    // headertoolBarTitleStyle: {
    //     width: "138px",
    //     textAlign: "center",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     color: "#3c424e",
    //     paddingRight: "0px"
    // },
    // Not used anywhere
    // mrRequestCellStyle: {
    //     margin: "0px",
    //     height: "48px",
    //     borderBottom: "1px solid #eef2f7",
    //     borderRight: "1px solid #eef2f7"
    // },
    // Not used anywhere
    // mrRequestLeftSpanStyle: {
    //     color: "#0b1322",
    //     fontWeight: "500",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px"
    // },
    // Not used anywhere
    // mrRequestRightSpanStyle: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     color: "#3c424e"
    // },
    // reportSummary: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     textAlign: "left",
    //     color: "#3c424e",
    //     margin: "16px 0px 16px 0px"
    // },
    // filterName: {
    //     fontWeight: "600",
    //     marginTop: "20px"
    // },
    // searchableSelectError: {
    //     color: "rgb(244, 67, 54)",
    //     fontSize: "12px",
    //     position: "absolute"
    // },
    // allTableNoDataText: {
    //     color: "#0b1322",
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "14px",
    //     fontWeight: 400,
    //     lineHeight: 1,
    //     backgroundColor: "#fff",
    //     display: "flex",
    //     justifyContent: "center",
    //     height: "65vh",
    //     paddingTop: 20
    // },
    // reportCycleheader: {
    //     color: "#3c424e",
    //     fontSize: "16px",
    //     fontWeight: "bold",
    //     fontFamily: "Roboto-Regular"
    // },
    // reportCycleCellEle: {
    //     fontFamily: "Roboto-Regular",
    //     fontSize: "12px",
    //     color: "#3c424e"
    // },
    // Not used Anywhere
    // searchFilterPageStyle: {
    //     travelRadio: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: 12,
    //         color: "#fff"
    //     },
    //     travelRadioExpanded: {
    //         fontFamily: "Roboto-Regular",
    //         fontSize: 13,
    //         color: "#000",
    //         fontWeight: "normal"
    //     }
    // },
    fieldcontainerRadioIconstyle: {
        width: "14px",
        height: "14px",
        marginRight: "5px",
        color: "#62d2a2",
        marginTop: "2px",
        fill: "#62d2a2",
        color: "red"
    },
    fieldcontainerRadioLabelstyle: {
        fontSize: "12px",
        color: "#3c424e",
        width: "100%",
        margin: "0px"
    },

    // userFieldcontainerRadioLabelstyle: {
    //     fontSize: "12px",
    //     color: "#3c424e",
    //     width: "100%",
    //     margin: "23px"
    // },
    uploadDocumentStyle: {
        position: "relative",
        /*top:"-45px", */
        fontSize: "12px",
        color: "#3c424e",
        width: "100%",
        margin: "23px"
    },
    fieldcontainerRadiostyle: {
        flex: 1,
        display: "flex",
        alignItems: "center"
    },
    // Not used anywhere
    // priSettlementChipStyle: {
    //     margin: 4,
    //     background: "rgba(0,0,0,-0.5)",
    //     border: "solid 1px #0b1322",
    //     display: "inline-flex"
    // },
    // Not used anywhere
    // priSettlementChipLabelStyle: {
    //     lineHeight: "33px",
    //     fontSize: "12px"
    // },
    // settlementOuterCelldivStyle: {
    //     padding: 20,
    //     backgroundColor: "#fff",
    //     borderRadius: "0px",
    //     borderBottom: "1px solid #eef2f7"
    // },
    // Not used anywhere
    // settlementInnerCelldivStyle: {
    //     paddingTop: 10,
    //     paddingBottom: 10,
    //     backgroundColor: "#fff",
    //     borderRadius: "6px",
    //     boxShadow: "0 0 5px 0 rgba(29, 29, 31, 0.1)",
    //     margin: "7px 30px"
    // },
    // Will se this later
    settlementPaperStyle: {
        padding: 0,
        minHeight: "calc(100vh - 310px)",
        maxHeight: "auto"
    },
    // settlementBetaInnerCelldivStyle: {
    //     backgroundColor: "#fff",
    //     borderRadius: "6px",
    //     boxShadow: "0 0 5px 0 rgba(29, 29, 31, 0.1)",
    //     border: "1px solid #d9e1ef",
    //     padding: "0px 16px"
    // },
    // Not used anywhere
    // passbookPaperStyle: {
    //     padding: 0,
    //     minHeight: "calc(100vh - 205px)",
    //     maxHeight: "auto"
    // },
    // Not used anywhere
    // policyViolation: {
    //     fontFamily: "Roboto-Medium",
    //     fontWeight: "550"
    // },

    navigateIcon: {
        color: "#7082a0",
        fontSize: "12px"
    },

    addMoreImagesButton: {
        boxShadow: "none",
        float: "left",
        margin: "15px"
    },

    addmoreImagesIcon: {
        borderRadius: "0%",
        width: "140px",
        height: "20px",
        // fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: "500",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "left",
        color: "#3c424e",
        backgroundColor: "transparent"
    },
    // uploadFileDialogStyle: {
    //     backgroundColor: "#f7f9fb",
    //     display: "inline-block",
    //     width: "100%",
    //     height: "62vh",
    //     fontFamily: "Roboto-Medium",
    //     textAlign: "center"
    // },
    // inneruploadFileDialogStyle: {
    //     backgroundColor: "#fff",
    //     height: "40vh",
    //     margin: "80px",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     flexDirection: "column"
    // },
    // fileUploadButton: {
    //     backgroundColor: "rgb(94, 137, 198)",
    //     borderRadius: "3px",
    //     color: "rgb(255, 255, 255)",
    //     margin: "15px"
    // },
    // omcTablePadd: {
    //     paddingLeft: 5
    // },
    // hotTableCardOmcPadd: {
    //     paddingLeft: 50
    // },
    // hotelPrefWrapper: {
    //     margin: "20px 0px",
    //     border: "1px solid rgb(232, 237, 244)",
    //     borderRadius: 10,
    //     padding: 10
    // },
    // limitMainDivContent: {
    //     padding: "20px",
    //     width: "90%",
    //     marginLeft: "38px",
    //     height: "80%"
    // },
    // limitheaderContent: {
    //     border: "1px solid #e0e0e0",
    //     padding: "20px",
    //     display: "inline-flex",
    //     width: "100%",
    //     marginBottom: "30px"
    // },
    // tableHeaderMainDiv: {
    //     margin: "auto",
    //     border: "1px solid rgb(224, 224, 224)",
    //     width: "65%"
    // },
    // limitTableStyle: {
    //     display: "-webkit-inline-box",
    //     position: "relative",
    //     width: "50%",
    //     borderRight: "1px solid rgb(224, 224, 224)"
    // },
    // Used in radio button style
    limitContentStyle: {
        padding: "10px",
        borderBottom: "1px solid #e0e0e0"
    },
    // vehiclelistCommon: {
    //     padding: "10px"
    // },

    vehiclePaperStyle: {
        padding: 0,
        minHeight: "calc(91vh - 321px)",
        maxHeight: "auto"
    },
    vehicleaddButton: {
        padding: "10px",
        textAlign: "right",
        position: "fixed",
        left: 0,
        bottom: 0,
        width: "100%",
        backgroundColor: "#ffffff",
        borderTop: "1px solid #ddd"
    },
    // publicKeyStyle: {
    //     color: "#0b1322",
    //     fontSize: "12px",
    //     fontWeight: 500,
    //     padding: "16px 0px 8px",
    //     fontFamily: "Roboto-Regular"
    // },
    tdStyleStickyPostion: {
        position: "sticky",
        left: 0,
        right: 0,
        backgroundColor: "#ffffff",
        height: "100%"
    },
    thStyleStickyPostion: {
        position: "sticky",
        left: 0,
        right: 0
        // backgroundColor: "#fcfcfc"
    },
    tdStyleStickyPostionTwo: {
        position: "sticky",
        left: 50,
        right: 50,
        backgroundColor: "#ffffff"
    },
    thStyleStickyPostionTwo: {
        position: "sticky",
        left: 50,
        right: 50
        // backgroundColor: "#fcfcfc"
    },
    headerStyleBulkHistory: {
        whiteSpace: "normal",
        border: "none",
        // fontFamily: "Roboto-Medium",
        fontWeight: 400,
        fontSize: 12,
        // backgroundColor: "#fcfcfc",
        color: "#0b1322",
        position: "sticky",
        top: 0
    }
};
